import { ITextProps, Shimmer, Text as FabricText, TooltipHost } from "@fluentui/react";
import React from "react";

import { Theme } from "../theme/Theme";

export interface TextProps
    extends Pick<ITextProps, "styles" | "block" | "nowrap" | "children" | "variant" | "onClick"> {
    disabled?: boolean;
    value?: string;
    tooltip?: string | JSX.Element;
    maxLength?: number;
    isLoading?: boolean;
    testId?: string;
    onClick?(): void;
}

export const Text: React.FunctionComponent<TextProps> = ({
    value,
    tooltip,
    children,
    block,
    nowrap,
    variant,
    maxLength,
    disabled,
    isLoading,
    styles: stylesProp,
    testId,
    onClick
}: TextProps) => {
    const styles = stylesProp as Record<string, Record<string, string>>;

    const isTextTooLong = (value?.length ?? 0) > (maxLength ?? Infinity);
    const tooltipContent = tooltip ?? (isTextTooLong ? value : undefined);

    if (isLoading) {
        <Shimmer style={{ maxWidth: "100%", height: "18.66px", position: "relative", top: "3px" }} />;
    }

    return (
        <TooltipHost content={tooltipContent} styles={{ root: { maxWidth: "100%" } }}>
            <FabricText
                data-testid={testId}
                block={block ?? true}
                nowrap={nowrap ?? true}
                variant={variant}
                styles={{
                    root: {
                        ...styles?.root,
                        color: disabled ? Theme.palette.neutralTertiary : styles?.root?.color,
                        textOverflow: "ellipsis"
                    }
                }}
                onClick={onClick}
            >
                {children || value}
            </FabricText>
        </TooltipHost>
    );
};
